import { render, staticRenderFns } from "./StLocationSearch.vue?vue&type=template&id=bedb04da"
import script from "./StLocationSearch.vue?vue&type=script&lang=ts"
export * from "./StLocationSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports